import { render, staticRenderFns } from "./bank-account.vue?vue&type=template&id=6efd2165&scoped=true&"
import script from "./bank-account.vue?vue&type=script&lang=js&"
export * from "./bank-account.vue?vue&type=script&lang=js&"
import style0 from "./bank-account.vue?vue&type=style&index=0&id=6efd2165&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd2165",
  null
  
)

export default component.exports